/* eslint-disable no-undef */
'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './sources.routes';

export class SourcesComponent {
  /*@ngInject*/
  constructor($http, $scope, $state, lookup, $anchorScroll, theme) {
    this.$http = $http;
    this.$scope = $scope;
    this.$state = $state;
    this.lookup = lookup;
    this.$anchorScroll = $anchorScroll;
    this.theme = theme;
  }

  $onInit() {
    if($('.tooltip')) {
      $('.tooltip').removeClass('show');
    }

    //Load theme functions
    this.theme.initTheme();

    //Load default anchor points
    this.$scope.screeningAnchor = true;

    // Get sources
    this.$http.get('https://data.bayareametro.gov/resource/7rg3-3vjs.json')
      .then(response => {
      // console.log(response.data);
      // Removed since I am no longer showing the dataset description here.
      // response.data.forEach(element => {
      //   element.intro = element.dataset_description.slice(0,200) + '...';
      // });
        this.$scope.environmentalConstraints = _.filter(response.data, {data_category: 'Environmental Constraint'});
        this.$scope.basicInformation = _.filter(response.data, {data_category: 'Basic Information'});
        this.$scope.planningConsiderations = _.filter(response.data, {data_category: 'Planning Consideration'});
        this.$scope.landuseAttributes = _.filter(response.data, {data_category: 'Land Use Information'});
        this.$scope.affh = _.filter(response.data, {data_category: 'Affirmatively Furthering Fair Housing'}); // NEW
        this.$scope.hcd = _.filter(response.data, {data_category: 'HCD Housing Sites Inventory'}); // NEW
      console.log(this.$scope.landuseAttributes)
      })
      .catch(err => {
        console.log(err);
      });
  }

  loadDetails(data) {
    console.log(data);
    this.lookup.setDataDetail(data);
    this.$state.go('detail');
  }

  goToSection(section, anchor) {
    if(section === 'screeningTabPanel') {
      $('#sourcesTabPanel').removeClass('active');
      $('#realisticcapacityTabPanel').removeClass('active');
      $('#screeningTabPanel').addClass('active');
      this.$scope.screeningAnchor = true;
      this.$scope.realCapacityAnchor = false;
      this.$scope.dataSourceAnchor = false;
    } else if(section === 'realisticcapacityTabPanel') {
      $('#sourcesTabPanel').removeClass('active');
      $('#screeningTabPanel').removeClass('active');
      $('#realisticcapacityTabPanel').addClass('active');
      this.$scope.screeningAnchor = false;
      this.$scope.realCapacityAnchor = true;
      this.$scope.dataSourceAnchor = false;
    } else if(section === 'sourcesTabPanel') {
      $('#realisticcapacityTabPanel').removeClass('active');
      $('#screeningTabPanel').removeClass('active');
      $('#sourcesTabPanel').addClass('active');
      this.$scope.screeningAnchor = false;
      this.$scope.realCapacityAnchor = false;
      this.$scope.dataSourceAnchor = true;
    }

    if(anchor) {
      switch (anchor) {
      case 'basicInfoAnchor':
        $('#collapseOne').addClass('show');
        $('#collapseTwo').removeClass('show');
        $('#collapseThree').removeClass('show');
        $('#collapseFour').removeClass('show');
        $('#collapseFive').removeClass('show');
        $('#collapseSix').removeClass('show');
        break;

      case 'landInfoAnchor':
        $('#collapseOne').removeClass('show');
        $('#collapseTwo').addClass('show');
        $('#collapseThree').removeClass('show');
        $('#collapseFour').removeClass('show');
        $('#collapseFive').removeClass('show');
        $('#collapseSix').removeClass('show');
        
        break;

      case 'enviroInfoAnchor':
        $('#collapseOne').removeClass('show');
        $('#collapseTwo').removeClass('show');
        $('#collapseThree').addClass('show');
        $('#collapseFour').removeClass('show');
        $('#collapseFive').removeClass('show');
        $('#collapseSix').removeClass('show');
        break;

      case 'planningInfoAnchor':
        $('#collapseOne').removeClass('show');
        $('#collapseTwo').removeClass('show');
        $('#collapseThree').removeClass('show');
        $('#collapseFour').addClass('show');
        $('#collapseFive').removeClass('show');
        $('#collapseSix').removeClass('show');
        break;

      case 'affhInfoAnchor':
        $('#collapseOne').removeClass('show');
        $('#collapseTwo').removeClass('show');
        $('#collapseThree').removeClass('show');
        $('#collapseFour').removeClass('show');
        $('#collapseFive').addClass('show');
        $('#collapseSix').removeClass('show');
        break;

        case 'hcdInfoAnchor':
        $('#collapseOne').removeClass('show');
        $('#collapseTwo').removeClass('show');
        $('#collapseThree').removeClass('show');
        $('#collapseFour').removeClass('show');
        $('#collapseFive').removeClass('show');
        $('#collapseSix').addClass('show');
        break;
      }
      this.$anchorScroll(anchor);
    } else {
      this.$anchorScroll();
    }
  }
}

export default angular.module('sources', [uiRouter])
  .config(routes)
  .component('sources', {
    template: require('./sources.html'),
    controller: SourcesComponent,
    controllerAs: 'sourcesCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/sources/sources.component.js